export default __webpack_public_path__ + "static/heroUnsolvedCase-be10552b7986aa43fa6ea59242ed74b2.jpg";